import { installAuthenticatedGeoFetch } from './geoAuthFetch';
import { ensurePmtilesProtocol } from './geoProtocol';
import { installSelfHostedOverpass } from './selfHostedOverpass';

// Install the authenticated fetch wrapper before MapLibre is imported. The PMTiles
// registration dynamically imports MapLibre so its request stack sees this wrapper.
installAuthenticatedGeoFetch();
void ensurePmtilesProtocol();
installSelfHostedOverpass();
